import { request } from '~/utils/request';
import { ModerationCard, ModerationItem, ModerationList } from 'features/moderation/types/gaz';

const BASE_URL = '/api/admin/gaz/moderation';

interface ListResponse {
  items: ModerationItem[],
  pagination: {
    page: number,
    perPage: number,
    total: number,
  },
}

export const moderationRead = request.table<ModerationList>(async ({ api, data }) => {
  const perPage = data.pagination.items || 20;
  const page = data.pagination?.page || 1;
  const pagination = `?page=${page}&perPage=${perPage}`;
  const search = data.filters.search
    ? `&search=${encodeURIComponent(data.filters.search)}`
    : '';

  const res = await api.get<ListResponse>(`${BASE_URL}/list${pagination}${search}`);
  if (res.error) {
    return {
      data: {
        rows: [],
        pagination: null,
      },
    };
  }

  const total = res.data.pagination?.total || 0;
  const itemPerPage = res.data.pagination?.perPage || perPage;

  return {
    data: {
      rows: res.data.items.map((item) => ({
        ...item,
        fio: `${item.firstName} ${item.lastName}`,
        departmentName: item.department?.name || '',
      })),
      pagination: {
        currentPage: res.data.pagination?.page || 1,
        totalPages: Math.max(1, Math.ceil(total / itemPerPage)),
        totalItems: total,
      },
    },
  };
});

export const moderationGet = request.card<ModerationCard, ModerationCard>(async ({ api, data, parseError }) => {
  const res = await api.get<ModerationItem>(`${BASE_URL}/${data.id}`);
  if (res.error) {
    return { error: parseError(res.error) };
  }

  return {
    data: {
      ...res.data,
      fio: `${res.data.firstName} ${res.data.lastName}`,
      departmentName: res.data.department?.name || '',
    },
  };
});

export const moderationApprove = request.card<any, ModerationCard>(async ({
  api, data, parseError, router,
}) => {
  const res = await api.post(`${BASE_URL}/${data.id}/approve`, {});
  if (res.error) {
    return { error: parseError(res.error) };
  }

  await router.push({ name: 'moderation' });
  return { data: res.data };
});

export const moderationReject = request.card<any, ModerationCard>(async ({
  api, data, parseError, router,
}) => {
  const res = await api.post(`${BASE_URL}/${data.id}/reject`, {});
  if (res.error) {
    return { error: parseError(res.error) };
  }

  await router.push({ name: 'moderation' });
  return { data: 'ok' };
});